import React, { useState, useEffect, useRef } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import AccordionItem from "./accordionItem";
import * as styles from './accordion.module.css';
import { gsap, TweenMax, Expo } from "gsap";

function accordion(props) {

    const [tabOpen, setTabOpen] = useState(0);
    
    const sectionRef = useRef();
    const contentRef = useRef();

    function toggleAccordion(key) {
        setTabOpen(key);
    }

    function toggleTab(key){
        setTabOpen(key);
    }

    useEffect(() => {
        
        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([contentRef.current], {
        //     opacity: 0,
        //     y: 80
        // });

        // if(!$(sectionRef.current).hasClass('anim-complete')){
        //     $(window).on('scroll', () => {
        //         if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){

        //             TweenMax.to(
        //                 contentRef.current, 
        //                 0.45, 
        //                 { 
        //                     opacity: 1, 
        //                     y: 0, 
        //                     delay : 0.25,
        //                     onComplete : () => {
        //                         $(sectionRef.current).addClass('anim-complete');
        //                     }
        //                 } 
        //             );
        //         }
        //     });
        // } else {
        //     TweenMax.set([contentRef.current], {
        //         opacity: 1,
        //         y: 0
        //     });
        // }

    });

    return (
        <div className={styles.accordionSection} ref={sectionRef}>
            <div className={styles.sectionContainer} ref={contentRef}>
                <div className={styles.textWrap}>
                    <h2>{props.heading}</h2>
                    <PortableText blocks={props.content} />
                </div>
                <div className={styles.accordionWrap}>
                    {
                        props.items.map((item, i) => {
                            return <AccordionItem item={item} key={i} index={'ac-'+i} />
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default accordion;